export default __webpack_public_path__ + "static/media/preflop-equity-handvshand_0017_thumb.e153180c.jpg";